var _require = require('prettier/standalone'),
    join = _require.doc.builders.join;

var AssemblyFor = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    return join(' ', ['for', path.call(_print, 'pre'), path.call(_print, 'condition'), path.call(_print, 'post'), path.call(_print, 'body')]);
  }
};
module.exports = AssemblyFor;